import { createApp } from 'vue'
import { createStore } from 'vuex'
import { createGtm } from '@gtm-support/vue-gtm'

import App from './App.vue'
import router from './router/router';
import { store } from './store/store.js';

const vueStore = createStore({
  modules: {
    store,
  },
})

createApp(App)
  .use(vueStore)
  .use(router)
  .use(
    // https://www.npmjs.com/package/@gtm-support/vue-gtm
    createGtm({
      id: process.env.VUE_APP_GTM,
      enabled: process.env.NODE_ENV === 'production',
      debug: process.env.NODE_ENV !== 'production',
      loadScript: false,
    })
  )
  .mount('#app')

// import { createApp } from 'vue'
// import Person from './Person.vue'
// createApp(Person).mount('#app')
